export default __webpack_public_path__ + "static/10_15-8dbcd61280f79fc58a8c35ec28dc6b45.png";